import { useEffect, useState } from "react";

/* Particules flottantes */
function Particle({ style }) {
  return <div style={style} />;
}

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: 4 + Math.random() * 10,
  left: Math.random() * 100,
  delay: Math.random() * 8,
  duration: 6 + Math.random() * 8,
  opacity: 0.08 + Math.random() * 0.18,
}));

export default function WhoWe() {
  const [revealed, setRevealed] = useState(false);
  const [dots, setDots]         = useState("");

  /* Animation "..." dans le sous-titre */
  useEffect(() => {
    const id = setInterval(() => setDots(d => d.length >= 3 ? "" : d + "."), 600);
    return () => clearInterval(id);
  }, []);

  /* Reveal progressif au chargement */
  useEffect(() => {
    const t = setTimeout(() => setRevealed(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "radial-gradient(ellipse at 60% 30%, #0a1f12 0%, #050d08 60%, #000 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      padding: "2rem",
    }}>

      {/* ── Particules ── */}
      {PARTICLES.map(p => (
        <Particle key={p.id} style={{
          position: "absolute",
          width: p.size,
          height: p.size,
          borderRadius: "50%",
          background: "radial-gradient(circle, #22c55e, #16a34a)",
          left: `${p.left}%`,
          bottom: "-20px",
          opacity: p.opacity,
          animation: `floatUp ${p.duration}s ${p.delay}s infinite ease-in-out`,
          pointerEvents: "none",
        }} />
      ))}

      {/* ── Halo vert derrière le logo ── */}
      <div style={{
        position: "absolute",
        width: 400,
        height: 400,
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(34,197,94,0.12) 0%, transparent 70%)",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -60%)",
        pointerEvents: "none",
        filter: "blur(8px)",
      }} />

      {/* ── Lignes de grille décoratives ── */}
      <div style={{
        position: "absolute", inset: 0,
        backgroundImage: `
          linear-gradient(rgba(34,197,94,0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(34,197,94,0.03) 1px, transparent 1px)
        `,
        backgroundSize: "60px 60px",
        pointerEvents: "none",
      }} />

      {/* ── Contenu ── */}
      <div style={{
        position: "relative",
        zIndex: 1,
        textAlign: "center",
        opacity: revealed ? 1 : 0,
        transform: revealed ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 1.2s ease, transform 1.2s ease",
      }}>

        {/* Logo WhoWe */}
        <div style={{
          marginBottom: 32,
          animation: "pulse 4s ease-in-out infinite",
        }}>
          <img
            src="/images/whowe_logo.png"
            alt="WhoWe"
            style={{
              width: 180,
              height: "auto",
              filter: "drop-shadow(0 0 32px rgba(34,197,94,0.45))",
            }}
          />
        </div>

        {/* Badge "top secret" */}
        <div style={{
          display: "inline-block",
          background: "rgba(34,197,94,0.08)",
          border: "1px solid rgba(34,197,94,0.3)",
          borderRadius: 30,
          padding: "6px 20px",
          marginBottom: 28,
          backdropFilter: "blur(8px)",
        }}>
          <span style={{
            color: "#4ade80",
            fontSize: "0.72rem",
            fontWeight: 800,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
          }}>
            🔒 &nbsp;Bientôt disponible
          </span>
        </div>

        {/* Titre */}
        <h1 style={{
          fontFamily: "'Alfa Slab One', 'Georgia', serif",
          fontSize: "clamp(3rem, 8vw, 5.5rem)",
          color: "#fff",
          lineHeight: 1.0,
          marginBottom: 8,
          textShadow: "0 0 60px rgba(34,197,94,0.3)",
          letterSpacing: "-0.02em",
        }}>
          WhoWe
        </h1>

        {/* Sous-titre animé */}
        <p style={{
          color: "rgba(255,255,255,0.45)",
          fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
          fontWeight: 500,
          marginBottom: 48,
          minHeight: "1.8em",
          letterSpacing: "0.02em",
        }}>
          Quelque chose arrive{dots}
        </p>

        {/* Message mystérieux */}
        <div style={{
          maxWidth: 480,
          margin: "0 auto 52px",
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(34,197,94,0.15)",
          borderRadius: 20,
          padding: "28px 32px",
          backdropFilter: "blur(12px)",
        }}>
          <p style={{
            color: "rgba(255,255,255,0.6)",
            fontSize: "1rem",
            lineHeight: 1.8,
            fontWeight: 400,
          }}>
            On ne peut pas encore tout vous dire.<br />
            Mais quand ça sera prêt,<br />
            <strong style={{ color: "#4ade80" }}>vous serez les premiers à le savoir.</strong>
          </p>
        </div>

        {/* Indicateur de progression */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
          <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.75rem", letterSpacing: "0.12em", textTransform: "uppercase" }}>
            En construction
          </span>
          <div style={{
            width: 200,
            height: 4,
            background: "rgba(255,255,255,0.08)",
            borderRadius: 4,
            overflow: "hidden",
          }}>
            <div style={{
              width: "42%",
              height: "100%",
              background: "linear-gradient(90deg, #16a34a, #4ade80)",
              borderRadius: 4,
              animation: "progressPulse 3s ease-in-out infinite",
            }} />
          </div>
          <span style={{ color: "#4ade80", fontSize: "0.72rem", fontWeight: 700 }}>42%</span>
        </div>
      </div>

      {/* ── Keyframes ── */}
      <style>{`
        @keyframes floatUp {
          0%   { transform: translateY(0) scale(1);    opacity: 0; }
          10%  { opacity: 1; }
          90%  { opacity: 0.6; }
          100% { transform: translateY(-110vh) scale(0.5); opacity: 0; }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1);    filter: drop-shadow(0 0 32px rgba(34,197,94,0.45)); }
          50%       { transform: scale(1.04); filter: drop-shadow(0 0 48px rgba(34,197,94,0.7)); }
        }
        @keyframes progressPulse {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}